/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@store/store";
import {
  setDocumentsAnexo1SecondGuarantee,
  setDocumentsLoading,
  setDocumentsSecondGuarantee,
} from "@store/slices/segundoAvalSlice";
import { BofuTabDocument } from "@interfaces/response";
import { useLazyGetTabsConfigQuery } from "@api/catalogs";
import { identifyPersons } from "@helpers/funciones";
import { UUID } from "crypto";
import { generateDocumentConfig, identityDocumentsByPerson, validateDocumentStructure } from "./functions";
import * as Sentry from "@sentry/react";
import {
  useLazyGetDocumentAppIdSecondGuaranteeQuery,
  useLazyGetPersonsSecondGuaranteeQuery,
} from "@api/second_guarantee_api/secondGuaranteeApi";
import { DOCUMENTS_CATALOG } from "@helpers/constantes";

const SegundoAvalDocuments = () => {
  const dispatch = useDispatch();

  const shareholder = useSelector((state: RootState) => state.secondGuarante.guarantee);

  const [getTabsConfig] = useLazyGetTabsConfigQuery();
  const [getDocsByAppId] = useLazyGetDocumentAppIdSecondGuaranteeQuery();
  const [getPersons] = useLazyGetPersonsSecondGuaranteeQuery();

  const generateTabsStructure = async () => {
    try {
      dispatch(setDocumentsLoading(true));

      const [tabs_config, persons, documents] = await Promise.all([
        getTabsConfig({ taxcode: "CS000" }).unwrap(),
        getPersons({
          loanApplicationId: shareholder.loan_application_id as UUID,
          id: shareholder.id as UUID,
        }).unwrap(),
        getDocsByAppId({
          loanApplicationId: shareholder.loan_application_id as UUID,
          personId: shareholder.id as UUID,
          status: true,
        }).unwrap(),
      ]);

      if (tabs_config.length === 0) {
        dispatch(setDocumentsLoading(false));
        return;
      }

      const { segundo_aval } = identifyPersons(persons);

      const { docs_segundo_aval } = identityDocumentsByPerson({
        documents,
        segundo_aval,
      });

      const { anexo_1 } = DOCUMENTS_CATALOG;

      const valid_documents: BofuTabDocument[] = [];

      tabs_config[0].documents
        .filter((item) => validateDocumentStructure(item))
        .forEach((docItem) => {
          const document_value = generateDocumentConfig({
            docItem,
            docs_account: [],
            docs_representante: [],
            docs_aval: [],
            docs_conyuge_aval: [],
            docs_segundo_aval,
            clientDetailsId: shareholder.client_details_id as UUID,
            representante: undefined,
            aval: undefined,
            conyuge_aval: undefined,
            segundo_aval,
          });

          valid_documents.push(document_value);
        });

      const doc_anexo_1 = docs_segundo_aval.find((item) => item.file_code === anexo_1.code);

      dispatch(setDocumentsAnexo1SecondGuarantee(doc_anexo_1));
      dispatch(setDocumentsSecondGuarantee(valid_documents));
    } catch (error) {
      console.error("Ha ocurrido un error al generar los documentos", error);
      Sentry.captureException(error, {
        extra: {
          component: "SegundoAval-generateTabsStructure",
        },
      });
    } finally {
      dispatch(setDocumentsLoading(false));
    }
  };

  useEffect(() => {
    generateTabsStructure();
  }, []);

  return null;
};

export default SegundoAvalDocuments;
